import { render, staticRenderFns } from "./OrgHomeIndex.vue?vue&type=template&id=8c606ee4&scoped=true&"
import script from "./OrgHomeIndex.vue?vue&type=script&lang=js&"
export * from "./OrgHomeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c606ee4",
  null
  
)

export default component.exports